import { Construction } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { EmptyState } from './EmptyState'
import { PageHeader } from './PageHeader'

/** Shell for screens that land in a later phase, so navigation and layout can be reviewed now. */
export function PlaceholderPage({ title, description, phase, icon = Construction, children }) {
  return (
    <>
      <PageHeader title={title} description={description} actions={<Badge variant="secondary">Phase {phase}</Badge>} />
      {children ?? (
        <EmptyState
          icon={icon}
          title={`Coming in Phase ${phase}`}
          description="This screen's layout and navigation are in place. Its features are built in the phase shown."
        />
      )}
    </>
  )
}
